import { HttpClient } from '@angular/common/http';
import { Base } from './base';
import { Pools } from './markets/pools';
import { Expiries } from './markets/expiries';
import { Accounts } from './markets/accounts';
import { Config } from './markets/config';
import { Ohlcs } from './markets/ohlcs';
import { Oracles } from './markets/oracles';
import { Settlements } from './markets/settlements';
import { TradeSignatures } from './markets/trade-signatures';
import { TradingVaults } from './markets/trading-vaults';

export class Markets extends Base {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'markets');
  }

  query(params?: any) {
    return this.api.query(params);
  }

  of(id: string) {
    return {
      accounts: new Accounts(this.httpClient, this.pathJoin(id)),
      config: new Config(this.httpClient, this.pathJoin(id)),
      expiries: new Expiries(this.httpClient, this.pathJoin(id)),
      pools: new Pools(this.httpClient, this.pathJoin(id)),
      tradingVaults: new TradingVaults(this.httpClient, this.pathJoin(id)),
      ohlcs: new Ohlcs(this.httpClient, this.pathJoin(id)),
      oracles: new Oracles(this.httpClient, this.pathJoin(id)),
      settlements: new Settlements(this.httpClient, this.pathJoin(id)),
      tradeSignatures: new TradeSignatures(this.httpClient, this.pathJoin(id))
    };
  }
}
